import CommonModal from "@/components/ui/CommonModal";
import {
  FlowFormPanelLayout,
  FormSectionLayout,
} from "@/components/ui/FlowFormPanel/FlowFormPanel";
import { useModal } from "@/hooks/modals/useModal";
import { Form } from "antd";
import type { PurchaseContractFormValues } from "../type";
import { PurchaseContractForm } from "./PurchaseContractForm";
import { useFormFooter } from "../hooks/useFormFooter";
import { useContractRecordQuery } from "../hooks/useContractRecordQuery";
import { useFlowNodeQuery } from "@/hooks/services/useFlow";
import ProcessTimeline from "@/components/SelfProcessTimeline";
import { useTranslation } from "react-i18next";

export function PurchaseContractModal() {
  const { t } = useTranslation("contractManagement");
  const { open, closeModal, props } = useModal("PURCHASE_CONTRACT");
  const { recordId, isFlowFinished, isReadOnly, flowStatus } = props;

  const [form] = Form.useForm<PurchaseContractFormValues>();
  const detail = useContractRecordQuery(recordId);
  const timeLineItems = useFlowNodeQuery(detail?.insId);

  const cleanup = () => {
    closeModal();
    form.resetFields();
  };
  const renderFooter = useFormFooter(form, cleanup);

  const showFlowStatusRules = [
    isReadOnly,
    flowStatus !== "已存档" && flowStatus !== "草稿",
  ];

  const showFlowStatus = showFlowStatusRules.some((r) => r);

  return (
    <CommonModal
      width={1200}
      title={t("合同审查申请")}
      centered
      open={open}
      onCancel={closeModal}
      footer={null}
    >
      <FlowFormPanelLayout
        leftPanel={
          <FormSectionLayout
            body={<PurchaseContractForm form={form} />}
            footer={renderFooter()}
          />
        }
        rightPanel={
          <ProcessTimeline
            items={timeLineItems}
            showFinishedFlag={isFlowFinished}
          />
        }
        showRightPanel={showFlowStatus && timeLineItems.length > 0}
      />
    </CommonModal>
  );
}
